<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >
        <a-spin :spinning="spinning">
        <a-row class="acol">
            <a-col :span="12" style="text-align: right">
                语种：
            </a-col>
            <a-col :span="10">
                {{a_langset_field_name}}
            </a-col>
        </a-row>
        <a-form-model
                ref="dynamicValidateForm"
                :model="dynamicValidateForm"
                :label-col="labelCol"
                :wrapper-col="wrapperCol"

        >
            <a-form-model-item
                    v-for="(domain, index) in dynamicValidateForm.domains"
                    :key="domain.a_langset_field_id"
                    :label="domain.a_langset_field_name"
                    :prop="'domains.' + index + '.content'"
                    :rules="{ required: true,message: '请填写语种内容',trigger: 'blur', }"
                    :help="domain.err||''"
                    :validateStatus='!domain.err||domain.err==""?"":"error"'
                   >
                <a-input :maxLength="200"
                        v-model="domain.content"
                        style="width: 60%; margin-right: 8px"
                         @change="(e) => { domain.err=''}"
                />
            </a-form-model-item>

        </a-form-model>
        </a-spin>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="submitForm('dynamicValidateForm')" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button  @click="onClose()" >
            取消
        </a-button>
        </div>

    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    export default {
        name: "languageForm",
        props: ["visible","title","editId"],
        data() {
            return {
                formErr:{},
                spinning: true,
                drawerConfig,
                a_langset_field_name:"",
                labelCol: {span:12},
                wrapperCol: {span:12},
                dynamicValidateForm: {
                    domains: [],
                },
                layout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 14 },
                },
                url:""
            };
        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.language.GET_EDITLISTS(a).then(res => {
                        if(res.data.data.data){
                            this.dynamicValidateForm.domains =res.data.data.data
                            this.a_langset_field_name=res.data.data.a_langset_name
                            this.url=API.language.SUBMIT_EDITLISTS
                        }else{
                            let data=res.data.data.info
                            if(!Array.isArray(data)) data=[data]
                            this.dynamicValidateForm.domains =data
                            this.a_langset_field_name=res.data.data.info.a_langset_name
                            this.url=API.language.SUBMIT_EDITLIST
                        }
                        this.spinning=false
                    })
                }
            }
        },
        methods: {
            onClose() {
                this.$emit("changVisible", false);
               this.dynamicValidateForm.domains=[]
                // this.$refs.ruleForm.resetFields();
            },
            submitForm(formName) {
                let _this=this
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        _this.dynamicValidateForm.domains.map((item,index)=>{
                            item.a_langset_id=item.a_langset_id
                            delete item["update_time"]
                            delete item["a_langset_field_name"]
                        })

                        submitForm(this.url, _this.dynamicValidateForm.domains).then(res => {
                                            if (res == true) {
                                                this.onClose()
                                            } else {
                                                res.map((item, index) => {
                                                    _this.dynamicValidateForm.domains[index].err=item.field
                                                })
                                            }
                                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.acol{font-weight: bold;margin-bottom: 15px}
</style>
